import { LegLocationTypeEnum } from '@/api/apis/route';

export type PrimaryLocationIds = {
  donorHospitalId?: string;
  txCenterId?: string;
};

type LocationRef = {
  locationType: LegLocationTypeEnum;
  locationId: string;
};

/**
 * Route may contain several DH/TXC locations, but only the case DH/TXC are primary segment locations.
 * When the primary id is unknown, any location of the given type is treated as primary.
 */
export const isPrimaryLocation = (
  ref: LocationRef,
  locationType: LegLocationTypeEnum.hospital | LegLocationTypeEnum.txcenter,
  primaryId?: string,
) => ref.locationType === locationType && (!primaryId || ref.locationId === primaryId);

export const isPrimaryHospital = (ref: LocationRef, primary: PrimaryLocationIds) =>
  isPrimaryLocation(ref, LegLocationTypeEnum.hospital, primary.donorHospitalId);

export const isPrimaryTxCenter = (ref: LocationRef, primary: PrimaryLocationIds) =>
  isPrimaryLocation(ref, LegLocationTypeEnum.txcenter, primary.txCenterId);
